import { cn } from "utils";
import { onboardingPricingCopy } from "./onboardingPricingCopy";
import type { OnboardingPricingOffer } from "./onboardingPricingOffers";

export const OnboardingPricingCard = ({
  offer,
  selected,
  locale,
  disabled,
  onSelect,
}: {
  offer: OnboardingPricingOffer;
  selected: boolean;
  locale?: string;
  disabled?: boolean;
  onSelect: () => void;
}) => {
  const copy = onboardingPricingCopy(offer, locale);
  return (
    <button
      type="button"
      aria-pressed={selected}
      disabled={disabled}
      data-openreplay-label="pricing_plan_select"
      data-or-event="paywall_plan_select"
      data-or-param-plan_id={offer.product.id}
      data-or-param-product_id={offer.purchaseProduct.id}
      data-or-param-sku={offer.purchaseProduct.id}
      data-or-param-cycle={offer.product.pay_cycle}
      data-or-param-pay_cycle={offer.product.pay_cycle}
      data-or-param-source="onboarding_first"
      data-or-param-title={copy.title}
      onClick={onSelect}
      className={cn(
        "border-2 text-left transition-colors w-[148px] shrink-0 rounded-[14px] px-[12px] py-[14px] md:w-full",
        selected
          ? "border-border_brand_transparent50 bg-background_brand_overlay10"
          : "border-border_inverse_transparent10 bg-background_solid_neutral_tertiary",
      )}
    >
      <div className="flex flex-col gap-[6px]">
        {copy.tag ? (
          <span
            className={cn(
              "w-fit rounded-1 px-2 py-1 body_medium_s text-content_primary",
              offer.key === "yearly"
                ? "bg-background_auralv3_overlay100"
                : "bg-background_white_overlay5",
            )}
          >
            {copy.tag}
          </span>
        ) : null}
        <span
          className={cn(
            "body_medium_m",
            selected ? "text-content_brand_secondary" : "text-content_primary",
          )}
        >
          {copy.title}
        </span>
        <span className="flex flex-wrap items-baseline gap-1 text-content_primary">
          <strong className="title_xxl">{copy.price}</strong>
          <span className="body_s text-content_secondary">{copy.unit}</span>
        </span>
        {copy.detail && (
          <span
            className={cn(
              "body_s",
              selected
                ? "text-content_brand_secondary"
                : "text-content_tertiary",
            )}
          >
            {copy.detail}
          </span>
        )}
      </div>
    </button>
  );
};
